import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPipe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"pipe, super mario, vpn"} maskId="square-filled-radius-0-stroke-1-IconPipe"><path d="M9 20H10V11H19V20H21V21H3V20H5V11H9V20Z" fill="currentColor"/><path d="M7 10H3V3H7V10Z" fill="currentColor"/><path d="M21 10H8V3H21V10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPipe;
